
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/unavailable",
      function () {
        return require("private-next-pages/unavailable.js");
      }
    ]);
  